export default __webpack_public_path__ + "df69dab0b5368cdbd9a2a1c3008cf2a8.svg";